import { render, staticRenderFns } from "./MessageSearch.vue?vue&type=template&id=6abfc656&scoped=true"
import script from "./MessageSearch.vue?vue&type=script&lang=js"
export * from "./MessageSearch.vue?vue&type=script&lang=js"
import style0 from "./MessageSearch.vue?vue&type=style&index=0&id=6abfc656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abfc656",
  null
  
)

export default component.exports